import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter  } from "reactstrap";//'react-bootstrap'; // Assuming Bootstrap is used for styling
import { FaTimes } from 'react-icons/fa';  // Import Font Awesome for cross icon
import axios from 'axios';

const ThumbnailDisplay = (props) => {
  const { thumbnails, handleRemoveImage,api_web_address, update_loc_loading, isLoading } = props
  //console.log(thumbnails)         api_web_address={api_web_address}
        //update_loc_loading={update_loc_loading}
        //isLoading={isLoading}
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');



  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);


  // Function to open the modal with the original image
  const handleShowModal = (image) => {
    const selectImage = image.replace("thumbnails", "images");
    setSelectedImage(selectImage);
    setShowModal(true);
    setModal(true);
    getImage(selectImage) //async get image
    console.group(selectImage)

  };
  // Function to close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedImage(null);
  };

  const getImage = async (selectedImage) => {
    update_loc_loading(true)
    setImageUrl('')
    try {
      const response = await axios.get(`${api_web_address}${selectedImage}`, {
        responseType: 'arraybuffer'
      });
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = URL.createObjectURL(blob);
        setImageUrl(url);
      } catch (error) {
        console.error(error);
      }
      update_loc_loading(false)
  };
  
  const imgContainer = () => {
    //https://codepen.io/YusukeNakaya/pen/XyOaBj
    if (imageUrl === "") {
      return (<div className="animated-background2">
        <div className="night">
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
            <div className="star"></div>
        </div>

</div>) 
    }

    if (imageUrl !== "") {
      return (
        <img
              src={imageUrl}
              alt="Original"
              className="img-fluid"
              style={{ width: '100%' }}
            />
      )
    }    
  }

  return (
    <div className="row mb-4">
      {thumbnails.map((thumbnail, index) => {
        return (
        <div className="col-md-3 mb-3" key={index}>
          <div className="card">
            <img
              src={`${api_web_address}${thumbnail}`}
              alt={`Thumbnail ${index}`}
              className="card-img-top"
              style={{ height: '150px', objectFit: 'cover' }}
              onClick={() => handleShowModal(thumbnail)} // Click to preview the original image
            />
            <div className="card-body text-center">
              <Button
                variant="danger"
                onClick={() => handleRemoveImage(thumbnail)}
              >
                Remove
              </Button>
            </div>
          </div>
        </div>
        )
        }
      
      )}

      {/* Modal for displaying the original image */}
      <Modal isOpen={modal} toggle={toggle}>
        {/* Custom close button with a cross icon */}
        <ModalHeader toggle={toggle} close={
          <button className="close" onClick={toggle} style={{ background: 'none', border: 'none' }}>
            <FaTimes />
          </button>
        }>


        <p className=''>
          {isLoading && (
            <span className="spinner-border text-primary p-1 m-1" role="status">
            </span>
          )}
{/* <div class="spinner-grow text-primary" role="status">
  <span class="sr-only">Loading...</span>  animated-background
</div> */}


        Original image
        </p> 

        </ModalHeader>
        <ModalBody>
          {imgContainer()}
        </ModalBody>
        <ModalFooter>

        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ThumbnailDisplay;
